import request from '../utils/request.js'
//绑定订单
export function sendGiftGoods(id) {
  return request({
    url:  process.env.MYURL + '/wework/sendGiftGoods?outOrderId=' + id,
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/sendGiftGoods.js